'use client';
import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

/**
 * Animated ring around a stock point indicating an alpha/beta zone signal.
 * `pulse` = smooth oscillation (entered alpha = bullish), `flash` = sharp on/off.
 */
export function SignalRing({ radius, color, mode }: {
  radius: number;
  color: string;
  mode: 'pulse' | 'flash';
}) {
  const ringRef = useRef<THREE.Mesh>(null);
  const matRef = useRef<THREE.MeshBasicMaterial>(null);

  useFrame(({ clock }) => {
    const t = clock.getElapsedTime();
    if (mode === 'pulse') {
      const s = 1 + 0.3 * Math.sin(t * 2);
      if (ringRef.current) ringRef.current.scale.setScalar(s);
      if (matRef.current) matRef.current.opacity = 0.4 + 0.3 * Math.sin(t * 2);
    } else {
      if (matRef.current) matRef.current.opacity = Math.sin(t * 4) > 0 ? 0.7 : 0.15;
    }
  });

  return (
    <>
      <mesh ref={ringRef} rotation={[Math.PI / 2, 0, 0]}>
        <ringGeometry args={[radius * 1.8, radius * 2.2, 32]} />
        <meshBasicMaterial ref={matRef} color={color} transparent opacity={0.5} side={THREE.DoubleSide} depthWrite={false} />
      </mesh>
      <mesh rotation={[0, 0, Math.PI / 2]}>
        <ringGeometry args={[radius * 1.8, radius * 2.2, 32]} />
        <meshBasicMaterial color={color} transparent opacity={0.2} side={THREE.DoubleSide} depthWrite={false} />
      </mesh>
    </>
  );
}
